import { DocumentItem } from './DocumentFile';

export class DocumentFolder implements DocumentItem {
  id: string | null;
  name: string | null;
  lastModified: Date | null;
  owner: string | null;
  url: string | null;
  siteId: string | null;

  constructor({ id, name, lastModified, owner, url, siteId }: DocumentFolder) {
    this.id = id;
    this.name = name;
    this.lastModified = lastModified;
    this.owner = owner;
    this.url = url;
    this.siteId = siteId;
  }
}
